/**
 * Doctors list – constants and type definitions
 */

export const FILTER_ALL_VALUE = 'all';

export interface StatusDateRow {
    status?: string;
    invitedAt?: string | null;
    linkedAt?: string | null;
    rejectedAt?: string | null;
    unlinkedAt?: string | null;
}

export interface ConnectionStatusOption {
    value: string;
    label: string;
}

export interface DoctorsListQueryParams {
    search: string;
    page: number;
    connectionStatusFilter: string;
}
